/**
 * Mobile Container Component
 * Wrapper component cho mobile experience
 */

import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import usePwaDisplayMode from '../../hooks/usePwaDisplayMode';
import '../../css/mobile-pwa.css';

const MobileAppContainer = ({ children }) => {
  const location = useLocation();
  const [pageTitle, setPageTitle] = useState('New Atlantic');
  const { isPwaExperience } = usePwaDisplayMode();

  // Page titles mapping
  const pageTitles = {
    '/': 'Trang chủ',
    '/vehicles': 'Quản lý xe',
    '/request-form': 'Tạo yêu cầu',
    '/notifications': 'Thông báo',
    '/profile': 'Hồ sơ cá nhân',
    '/vehicle-management': 'Quản lý xe',
    '/approval-dashboard': 'Phê duyệt',
    '/driver-profiles': 'Tài xế',
    '/reports': 'Báo cáo'
  };

  useEffect(() => {
    // Update page title based on current route
    const title = pageTitles[location.pathname] || 'New Atlantic';
    setPageTitle(title);
    document.title = `${title} - New Atlantic`;
  }, [location.pathname]);

  useEffect(() => {
    if (typeof document === 'undefined') return undefined;

    document.documentElement.classList.toggle('pwa-standalone-mode', isPwaExperience);
    document.body.classList.toggle('pwa-standalone-mode', isPwaExperience);

    return () => {
      document.documentElement.classList.remove('pwa-standalone-mode');
      document.body.classList.remove('pwa-standalone-mode');
    };
  }, [isPwaExperience]);

  // Render only if it's mobile PWA (standalone experience)
  if (!isPwaExperience) {
    return children;
  }

  return (
    <div className="pwa-mobile-container">
      <main className="pwa-main-content mobile-pull-to-refresh">
        {children}
      </main>
    </div>
  );
};

export default MobileAppContainer;
